import { useEffect } from 'react';
import EVENTS from '@/utils/Constants/Events';

// Context
import { useCompareContext } from '@/context/compare';

export default () => {
  const [{ materialGroup, productsCode }] = useCompareContext();
  const disableNotComparableProducts = () => {
    const productCompareInputs = document.querySelectorAll(
      '.js-product-box-compare',
    );

    if (materialGroup) {
      Array.from(productCompareInputs).forEach(input => {
        let isDisabled = false;
        if (productsCode.length >= 3) {
          isDisabled = !productsCode.includes(input.dataset.productCode);
        } else {
          isDisabled = input.dataset.materialGroup !== materialGroup;
        }
        input.disabled = isDisabled;
        input.parentElement.classList[isDisabled ? 'add' : 'remove'](
          'disable-all',
        );
      });
    } else {
      Array.from(productCompareInputs).forEach(input => {
        input.disabled = false;
        input.parentElement.classList.remove('disable-all');
      });
    }
  };

  useEffect(() => {
    disableNotComparableProducts();
    DLG.EVE.on(EVENTS.LISTING.COMPARE.UPDATE, disableNotComparableProducts);
  }, [materialGroup, productsCode]);
};
